import classNames from "classnames";
import { isArray, isEmpty, isEqual, isFunction } from "lodash";
import React from "react";

import MobileNavigationLink from "./MobileNavigationLink";
import withUserData from "../../../../../../hocs/withUserData";
import { showModal } from "../../../../../../lib/react-redux-modal-provider";

function MobileNavigationLinks({
  submenu,
  onOpenSubmenu,
  links = [],
  hasPermission
}) {
  return (
    <ul className={classNames("mobile-navigation__list")}>
      {links.map(link => {
        const { label: childLabel, children, onClick } = link;
        const isActive = isEqual(link, submenu);
        const hasChildren = isArray(children) && !isEmpty(children);

        const hasPermissionToEnterPage = hasPermission(link?.permissions);

        return (
          <li key={childLabel}>
            <MobileNavigationLink
              {...link}
              onClick={async () => {
                if (!hasPermissionToEnterPage) {
                  showModal("PremiumModal", {
                    permissions: link?.permissions
                  });
                  return;
                }

                if (hasChildren) {
                  await onOpenSubmenu(link);
                }

                if (isFunction(onClick)) {
                  await onClick();
                }
              }}
              href={hasPermissionToEnterPage ? link.href : undefined}
              active={isActive}
            />
          </li>
        );
      })}
    </ul>
  );
}

export default withUserData(MobileNavigationLinks);
